import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import { Navigation } from "react-router";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";

export default statics(
  {
    willTransitionTo({ location }, replace, callback) {
      OrderActions.newOrderFlow();
      OrderActions.updateCurrentOrder({
        return: location.query.return,
        subitems: [
          {
            gift_card: true,
            price: +location.query.amount || 0,
            senderName: location.query.senderName,
            recipientName: location.query.recipientName,
            recipientEmail: location.query.recipientEmail,
            giftMessage: location.query.giftMessage,
            giftScheduledSend: location.query.giftScheduledSend,
          }
        ]
      });
      callback();
    }
  },

  @connectToStores
  class GiftCardsOverlay extends React.Component {
    constructor(props) {
      super(props);
      this.cancel = this.cancel.bind(this);
    }

    static getStores() {
      return [OrderStore, PersonStore];
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired,
        tenant: React.PropTypes.object.isRequired
      };
    }

    static getPropsFromStores() {
      var state = OrderStore.getState();
      state.getOrderById = OrderStore.getOrderById;
      state.isLoggedIn = PersonStore.getState().isLoggedIn;
      state.person = PersonStore.getState().details;
      return state;
    }

    componentWillReceiveProps(newProps) {
      if (
        newProps.orderData.price &&
        newProps.orderData.price !== +newProps.location.query.amount
      ) {
        this.context.router.replace({
          pathname: "/giftcards/go",
          query: { amount: newProps.orderData.price }
        });
      }
    }

    cancel() {
      if (!(this.props.orderInProgress || this.props.orderSuccess)) {
        if (
          this.props.location.state &&
          this.props.location.state.fromMainListing
        ) {
          this.context.router.goBack();
        } else {
          this.context.router.push(`/giftcards`);
        }
      }
    }

    submit() {
      OrderActions.submitOrder.defer();
    }

    render() {
      return (
        <BaseOverlay onRequestClose={this.cancel}>
          <Checkout
            orderInProgress={this.props.orderInProgress}
            orderSuccess={this.props.orderSuccess}
            orderErrorMessage={this.props.orderErrorMessage}
            orderData={this.props.orderData}
            updateCurrentOrder={OrderActions.updateCurrentOrder}
            completedOrder={this.props.getOrderById(
              this.props.completedOrderId
            )}
            person={this.props.person}
            isLoggedIn={this.props.isLoggedIn}
            item={{
              name: `${TENANT.display_short_name} Gift Card`,
              donation: false
            }}
            variablePrice={true}
            hideQuantity={true}
            hideCouponEntry={true}
            forceShowPaymentSummary={true}
            buyLabel={"Buy Gift Card"}
            actionVerb={"giftcard"}
            cancel={this.cancel}
            submit={this.submit}
          />
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/gift-cards.jsx